"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var avatar_1 = require("../avatar");
var UserBanner = /** @class */ (function (_super) {
    tslib_1.__extends(UserBanner, _super);
    function UserBanner(props, context) {
        return _super.call(this, props, context) || this;
    }
    UserBanner.prototype.render = function () {
        var _a = this.props, className = _a.className, theme = _a.theme, avatarUrl = _a.avatarUrl, title = _a.title, description = _a.description, dark = _a.dark;
        var classes = classnames_1.default(theme.banner, className);
        return (React.createElement("div", { className: classes },
            React.createElement("div", { className: theme.avatar },
                React.createElement(avatar_1.Avatar, { imageUrl: avatarUrl, dark: dark })),
            React.createElement("div", { className: theme.info },
                React.createElement("div", { className: theme.title }, title),
                React.createElement("div", { className: theme.description }, description))));
    };
    UserBanner.defaultProps = {};
    return UserBanner;
}(React.Component));
exports.default = UserBanner;
